import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NotificationIdentifier } from '@evorait/pace-core';

@Component({
    selector: 'pace-forms-base-forms-list',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './base-forms-list.component.html',
    styleUrl: './base-forms-list.component.scss',
})
export class BaseFormsListComponent {
    @Input()
    public notificationIdentifier: NotificationIdentifier;

    @Input()
    public useFormListCache: boolean;
}
